import React from 'react'
import styled from 'styled-components'

import Wrapper from 'components/Wrapper'
import Header from 'components/Header'
import { white, borderColor } from 'styles/colors'
import { media, mediaDown } from 'styles/media'
import { H1, H3, fontWeights, lineHeights } from 'styles/typography'
import * as spacing from 'styles/spacing'
import Wave from 'images/vype-plus/header-wave.svg'

const Container = styled.div`
  position: relative;
  text-align: center;
  overflow: hidden;
  margin-bottom: -3rem;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 178px;
    background-color: #15171e;

    ${media.small`
      bottom: 195px;
    `};

    ${media.medium`
      display: none;
    `};
  }

  ${media.medium`
    text-align: left;
    margin-bottom: -4rem;
  `};

  ${media.large`
    margin-bottom: -5rem;
  `};

  ${media.xLarge`
    margin-bottom: -7rem;
  `};
`

const Inner = styled.div`
  padding-top: 7rem;
  padding-bottom: 0;

  ${media.small`
    padding-top: 8rem;
    padding-bottom: 0;
  `};

  ${media.medium`
    padding-top: 10rem;
    padding-bottom: 22rem;
  `};

  ${media.large`
    padding-top: 11rem;
    padding-bottom: 25rem;
  `};

  ${media.xLarge`
    padding-top: 12rem;
    padding-bottom: 28rem;
  `};
`

const Content = styled.div`
  position: relative;
  z-index: 10;

  ${media.medium`
    padding-left: 2vw;
  `};

  ${media.large`
    padding-left: 5%;
  `};

  ${media.xLarge`
    padding-left: 7%;
  `};
`

const Heading = styled(H1)`
  color: ${white};
  font-weight: ${fontWeights.regular};
  margin-bottom: 0.4em;
  font-size: 40px;

  ${media.small`
    font-size: 46px;
  `};

  ${media.medium`
    font-size: 52px;
  `};

  ${media.large`
    font-size: 56px;
    margin-bottom: 0.5em;
  `};

  ${media.xLarge`
    font-size: 62px;
  `};
`

const Subheading = styled.div`
  display: block;
  max-width: 330px;

  ${media.small`
    max-width: 360px;
  `};

  ${media.medium`
    max-width: 460px;
  `};

  ${mediaDown.medium`
    margin-left: auto;
    margin-right: auto;
  `};
`

const SubheadingString = styled(H3)`
  display: inline;
  margin: 0;
  color: ${borderColor};
  font-weight: ${fontWeights.regular};
  line-height: ${lineHeights.base};
`

const FigureWrap = styled.div`
  position: static;
  max-width: 480px;

  ${media.small`
    margin-top: ${spacing.medium};
  `};

  ${mediaDown.medium`
    margin-left: auto;
    margin-right: auto;
  `};

  ${media.medium`
    position: absolute;
    left: 45%;
    top: 50%;
    width: 600px;
    transform: translateY(-25%);
    margin-top: -2%;
    max-width: 700px;
  `};

  ${media.large`
    width: 660px;
  `};
`

const Figure = styled.img`
  position: static;
`

const Background = styled(Wave)`
  position: absolute;
  top: 0;
  left: 0;
  width: 140%;
  height: 100%;
  margin-left: -20%;
  preserve-aspect-ratio: none;

  ${media.large`
    width: 120%;
    margin-left: -10%;
    margin-top: -20px;
  `};

  ${media.xLarge`
    width: 100%;
    margin-left: 0;
    margin-top: -40px;
  `};

  ${mediaDown.medium`
    display: none;
  `};
`

const PlusHeader = () => (
  <Container>
    <Header transparent />
    <Inner>
      <Wrapper>
        <Content>
          <Heading>
            This is <strong>Vuse+</strong>
          </Heading>
          <Subheading>
            <SubheadingString as="h3">A rewards program exclusively for vuse.com customers</SubheadingString>{' '}
            <SubheadingString as="h2">with monthly vaping deals and special offers.</SubheadingString>
          </Subheading>
          <FigureWrap>
            <Figure
              src={`${process.env.BASE_PATH}/images/vype-plus/card-stack-mobile.png`}
              className="u-hide-medium-up"
              alt="Vuse plus vape deals"
            />
            <Figure
              src={`${process.env.BASE_PATH}/images/vype-plus/card-stack.png`}
              className="u-hide-medium-down"
              alt="Vuse plus vape deals"
            />
          </FigureWrap>
        </Content>
      </Wrapper>
    </Inner>
    <Background />
  </Container>
)

export default PlusHeader
